import React from "react";
import { Link } from "react-router-dom";
import withRole from "../../../../../Providers/AuthProvider/WithRole";

const CheckInOutLink = () => {
    return <Link to="/check/cars"> Pick Up / Returns </Link>;
};

export default withRole(CheckInOutLink, ["admin", "employee"]);
